export default __webpack_public_path__ + "static/media/upload.b0c77a8a.jpg";